import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Connection from "../../elements/connection/Connection";
import { NavLink, useHistory } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import MaterialPagination from "../../styles/materialPagination";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { removeTransferFromCollection } from "../../../utils/collections";
import { useTranslation } from "react-i18next";

import { StyledServiceGrid, StyledServiceLink } from "../../services/styledServices";
import ConnectedServicesFilter from "./ConnectedServicesFilter";

const ConnectedServicesList = ({ project }) => {
  const { t } = useTranslation("connectionServicesPage");
  const [connections, setConnections] = useState();
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "currentTab": checkFilterItem(history, "currentTab", project.name, false, true),
    "service.name": checkFilterItem(history, "service.name", null)
  });

  useEffect(() => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/connections" + filterUrl + "&project.id=" + project.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setConnections(removeTransferFromCollection(response.data["hydra:member"]));
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {

    });
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  if (!connections) {
    return <PageSpinner position="center" pt="60" pb="60" />;
  }

  return (
    <div>
      <ConnectedServicesFilter
        filterData={filterData}
        setFilterData={setFilterData}
      />
      {connections.length === 0 ?
        <Alert severity="warning">{t("table.emptyData")}</Alert> :
        <StyledServiceGrid>
          {connections.map((value, key) => (
            <Connection
              name={value.service.name}
              enablePayment={value.enablePayment}
              enablePayout={value.enablePayout}
            />
          ))}
        </StyledServiceGrid>}
      {totalPageCount &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </div>
  );
};

export default ConnectedServicesList;